module.exports = ".full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/tecnicasterapeuticas/tecnicasterapeuticasdetalle/tecnicasterapeuticasdetalle.component.scss
// module id = ./src/app/consulta/tecnicasterapeuticas/tecnicasterapeuticasdetalle/tecnicasterapeuticasdetalle.component.scss
// module chunks = main